//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[["numConnections","ownerParts","names"],"GetConnectionNames",{},0,0],[["ownerParts","names"],"SetConnectionNames",{},2,0],[["instanceName","ownerPart","remoteIP","remotePort","station","eEndian"],"GetConnectionInformation",{},2,0],[["instanceName","ownerPart","remoteIP","remotePort","station","eEndian"],"SetConnectionInformation",{},6,0],[["instanceName","ownerPart","numChannels","channels"],"GetChannels",{},2,0],[["instanceName","ownerPart","channels"],"SetChannels",{},3,0],[["instanceName","ownerPart","channelName","numSignals","channels"],"GetSignals",{},3,0],[["instanceName","ownerPart","channelName","signals"],"SetSignals",{},4,0]],[]];
SPLM.Mechatronics.ModbusTCPClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ModbusTCPClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ModbusTCPClientBuilder.SignalEx = class{
    constructor(name,strDataType,eIOType,strAddress,nWord,nBit){
        this.name=name;this.strDataType=strDataType;this.eIOType=eIOType;this.strAddress=strAddress;this.nWord=nWord;this.nBit=nBit;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Strdatatype(){return this.strDataType}
    set Strdatatype(val){this.strDataType = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Straddress(){return this.strAddress}
    set Straddress(val){this.strAddress = val}
    get Nword(){return this.nWord}
    set Nword(val){this.nWord = val}
    get Nbit(){return this.nBit}
    set Nbit(val){this.nBit = val}
};

SPLM.Mechatronics.ModbusTCPClientBuilder.Channel = class{
    constructor(name,eAccessType,dCycleTime,nOffset,nLength){
        this.name=name;this.eAccessType=eAccessType;this.dCycleTime=dCycleTime;this.nOffset=nOffset;this.nLength=nLength;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eaccesstype(){return this.eAccessType}
    set Eaccesstype(val){this.eAccessType = val}
    get Dcycletime(){return this.dCycleTime}
    set Dcycletime(val){this.dCycleTime = val}
    get Noffset(){return this.nOffset}
    set Noffset(val){this.nOffset = val}
    get Nlength(){return this.nLength}
    set Nlength(val){this.nLength = val}
};

SPLM.Mechatronics.ModbusTCPClientBuilder.JaModbustcpclientAccesstype = Object.freeze({
    "ReadCoils" : "ReadCoils", "ReadDiscreteInputs" : "ReadDiscreteInputs", "ReadHoldingRegisters" : "ReadHoldingRegisters", "ReadInputRegisters" : "ReadInputRegisters", "WriteSingleCoil" : "WriteSingleCoil", "WriteSingleRegister" : "WriteSingleRegister", "WriteMultipleCoils" : "WriteMultipleCoils", "WriteMultipleRegisters" : "WriteMultipleRegisters"});

SPLM.Mechatronics.ModbusTCPClientBuilder.JaModbustcpclientEndiantype = Object.freeze({
    "Abcd" : "Abcd", "Badc" : "Badc", "Cdab" : "Cdab", "Dcba" : "Dcba"});

export default SPLM;